import React from 'react'
import image from './../../static/logos/logo.jpg'

const Image = () => <img alt="logo" style={{ borderRadius: '50%' }} src={image} />
export default Image
